import Tabs from '@commons/tabs'
import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Banners from './components/banners'
import Promos from './components/promos'
import HealthAdvices from './components/healthAdvices'
const AdminMarketingSettingsPage = () => {
  const tabs = [
    {
      title: 'Banners',
      key: 'banners',
      Component: Banners,
    },
    {
      title: 'Promos Codes',
      key: 'promos',
      Component: Promos,
    },
    {
      title: 'Health Advices',
      key: 'health-advices',
      Component: HealthAdvices,
    },
  ]
  return (
    <Column>
      <Column styleColumn="margin-bottom:20px;">
        <SectionHeading title="Marketing Settings" />
      </Column>
      <Tabs items={tabs} restore={true} />
    </Column>
  )
}

export default AdminMarketingSettingsPage
